import { JobCampaignField } from 'lib/enum/job-campaign-fields.enum';
import { privateApi } from 'services';
import { ImporterSettingsItem } from './types';

const fetchImporterSettingsItem = async (jobGroupId: string): Promise<ImporterSettingsItem> =>
    privateApi.get<ImporterSettingsItem>(`job-group-importer-settings/${jobGroupId}`);

const runImporter = async (jobGroupId: string): Promise<ImporterSettingsItem> =>
    privateApi.post<ImporterSettingsItem>(`job-group-importer-settings/${jobGroupId}/run-importer`, {});

const updateLinkedFields = async (
    jobGroupId: string,
    linkedFields: JobCampaignField[],
): Promise<ImporterSettingsItem> =>
    privateApi.put<ImporterSettingsItem>(`job-group-importer-settings/${jobGroupId}`, {
        linkedFields,
    });

const enableImporter = async (jobGroupId: string): Promise<ImporterSettingsItem> =>
    privateApi.post<ImporterSettingsItem>(`job-group-importer-settings/${jobGroupId}/enable-importer`, {});

const disableImporter = async (jobGroupId: string): Promise<ImporterSettingsItem> =>
    privateApi.post<ImporterSettingsItem>(`job-group-importer-settings/${jobGroupId}/disable-importer`, {});

export const ImporterSettingsItemGateway = {
    fetchImporterSettingsItem,
    runImporter,
    updateLinkedFields,
    enableImporter,
    disableImporter,
};
